export default "__VITE_ASSET__Bidc33Ce__"